import { useMemo } from 'react';
import { useNotifications } from '@toolpad/core/useNotifications';

import { AlertOptionsType } from 'types';
import { getErrorMessage } from 'utils/error';

export const useAlert = () => {
  const notifications = useNotifications();

  const showAlert = (message: string, options: AlertOptionsType) => {
    notifications.show(message, {
      autoHideDuration: options?.timeout || 5000,
      severity: options?.type === 'success' ? 'success' : 'error',
    });
  };

  const handleError = (error: any) =>
    showAlert(getErrorMessage(error), { type: 'error' });

  const showSuccessAlert = (message: string, options?: AlertOptionsType) =>
    showAlert(message, { type: 'success', ...options });

  const showErrorAlert = (message: string, options?: AlertOptionsType) =>
    showAlert(message, { type: 'error', ...options });

  return useMemo(
    () => ({
      handleError,
      showErrorAlert,
      showSuccessAlert,
    }),
    []
  );
};
